import type { ReactNode } from "react";
import { cn } from "./cn.js";

type Props = {
  icon?: ReactNode;
  title: ReactNode;
  hint?: ReactNode;
  action?: ReactNode;
  className?: string;
};

/** Centered empty-state callout — used by panels when no project is picked
 *  or a list has no items. */
export function EmptyState({ icon, title, hint, action, className }: Props) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 text-center p-10 rounded-lg",
        "border border-dashed border-border bg-surface-muted/30",
        className,
      )}
    >
      {icon && <div className="text-ink-faint">{icon}</div>}
      <div>
        <div className="text-[15px] font-semibold text-ink">{title}</div>
        {hint && <div className="text-[13px] text-ink-muted mt-1">{hint}</div>}
      </div>
      {action}
    </div>
  );
}
